module.exports = __webpack_public_path__ + "media/images/expert__placeholder-bfe339a76a322cb7a45edeaf324f6141.png";